import { Link, navigate } from 'gatsby'
import React, { useEffect } from 'react'
import * as Styles from './index.module.scss'
import { ContactPageTitle } from '@/components/contact/contact-page-title'
import { ServicePointContainer } from '@/components/contact/service-point-container'
import { ContactForm } from '@/components/form/contact-form'
import { Layout } from '@/components/general/layout'
import { Seo } from '@/components/general/seo'
import { pagesPath } from '@/lib/pagesPath'
import { useFormStorage } from '@/lib/use-form-storage'

const ContactPage = ({ location }) => {
  const { getFormStorage, setFormStorage, cleanFormStorage } = useFormStorage()
  const formState = getFormStorage()

  useEffect(() => {
    if (formState) {
      return () => cleanFormStorage()
    }
  }, [])
  return (
    <Layout location={location}>
      <Seo
        title="お問い合わせ"
        description="クラウド決算開示管理サービス【Uniforce】へのご質問、ご相談はこちらから。 内容確認後、担当より通常1営業日以内にご連絡いたします。"
      />
      <ContactPageTitle
        title="サービスに関するお問い合わせ"
        en="CONTACT"
        readText={
          <div className={Styles.readText}>
            クラウド決算開示管理サービス｜Uniforceや、
            <br className="sp" />
            コンサルティングサービスなど、
            <br className="pc" />
            弊社サービスに関する
            <br className="sp" />
            お問い合わせは下記フォームよりお願いいたします。
            <br />
            <span>すでにサービスをご契約されている方</span>の
            <br className="sp" />
            お問い合わせは
            <Link to={pagesPath.contactUser.$url()}>こちら</Link>。
          </div>
        }
        className={Styles.contactPageTitle}
      />

      <div className={Styles.container}>
        <ContactForm
          className={Styles.form}
          initFormState={{
            ...formState,
            contract: '未契約',
            agree_flag: false,
          }}
          submitHandler={async (state) => {
            setFormStorage(state)
            await navigate(pagesPath.contact.confirmation.$url())
          }}
        />
        <ServicePointContainer />
      </div>
    </Layout>
  )
}

export default ContactPage
